// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OpeningHourScheduleResponse

import { OpeningHourDay } from './enums.gen';
import { hydrateOpeningHourTime, type OpeningHourTime, type OpeningHourTimeApiResponse } from './openingHourTime.gen';

export type OpeningHourScheduleApiResponse = {
	day: OpeningHourDay;
	openingHours: OpeningHourTimeApiResponse[];
};

export type OpeningHourSchedule = {
	day: OpeningHourDay;
	openingHours: OpeningHourTime[];
};

export function hydrateOpeningHourSchedule(data: OpeningHourScheduleApiResponse): OpeningHourSchedule {
	return {
		...data,
		openingHours: data.openingHours.map(hydrateOpeningHourTime),
	};
}